import React from 'react'
import cx from 'classnames'
import { reportToggleFiltersPanel } from '../../../../../common/analytics/filtersAnalytics'

import styles from './index.module.css'

import ShowFilters from '../../../../shared/components/icons/showFilters'

const ToggleButton = ({ expanded, toggleSidebar }) => {
  let buttonClass = cx(styles.buttonToggle, {
    [styles.active]: expanded,
    [styles.deactive]: !expanded
  })

  const onClickHandler = () => {
    reportToggleFiltersPanel(expanded)
    toggleSidebar()
  }

  return (
    <div className={styles.toggleContainer}>
      <button className={buttonClass} onClick={onClickHandler}>
        <ShowFilters width="18" height="18" />
        <span className={styles.label}>Filter & Refine</span>
      </button>
    </div>
  )
}

export default ToggleButton
